<template>
    <div class="section-dark resume">
        <div class="container">
            <div class="" data-aos="fade-in" data-aos-easing="linear">
                <div class="quote subtitle is-size-2 has-text-centered">A day without laughter is a day wasted   <br>
                    :D </div>
                <div class="left has-text-right subtitle is-4">
                    ~ Charlie Chaplin
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: "Quote"
    }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,500&display=swap');
    .quote {
        font-family: 'Playfair Display', serif;
        padding: 0 1rem;
    }
    .left {
        padding-right: 1rem;
    }
    /*@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@1,300&display=swap');*/

</style>
